import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { ErrorBoundary } from '../../../components/common/ErrorBoundary'
import { useAppTranslation } from '../../../hooks/useAppTranslation'
import { theme } from '../../../theme/theme'
import { BackButton } from '../../../components/common/BackButton'
import { CreateSocietyForm } from '../../../components/find-society/CreateSocietyForm'
import { SocietyTypes } from '../../../types/society-type'
import { useDocumentTitle } from '../../../hooks/useDocumentTitle'
import { reverseDocumentTitle } from '../../../navigation/reverseDocumentTitle'
import { useAuth } from '../../../hooks/useAuth'
import { userQueries } from '../../../api/users'

export const CreateSocietyView = (): React.ReactNode => {
  const { translate } = useAppTranslation()
  const { userId } = useAuth()
  const navigate = useNavigate()
  useDocumentTitle(reverseDocumentTitle('create-society'))
  const { state } = useLocation()
  const { societyTypeDisplayName } = state || {}
  const { data: user } = useQuery(userQueries.getUser(userId))

  const goBack = (): void => {
    navigate(-1)
  }

  const societyIsSamf =
    societyTypeDisplayName === SocietyTypes.HOME_OWNERS_ASSOCIATION
  const societyIsRealStateDeveloper =
    societyTypeDisplayName === SocietyTypes.HOUSING_COOPERATIVE_CONSTRUCTION
  const isNeighbourhood = societyTypeDisplayName === SocietyTypes.NEIGHBOURHOOD

  const getTitle = (): string => {
    if (societyIsSamf) {
      return translate('createSocietyForm.samfTitle')
    }
    if (societyIsRealStateDeveloper) {
      return translate('createSocietyForm.realEstateDeveloperTitle')
    }
    if (isNeighbourhood) {
      return translate('createSocietyForm.neighbourhoodTitle')
    }
    return translate('createSocietyForm.brfTitle')
  }

  const title = getTitle()

  if (!societyTypeDisplayName) {
    return <></>
  }

  return (
    <ErrorBoundary>
      <div className="h-full w-full p-6">
        <div className="flex items-center space-x-4">
          <BackButton onClick={goBack} />
          <p style={theme.textVariants.h2}>{title}</p>
        </div>
        <div className="h-full w-full overflow-y-auto py-2 pr-4 md:py-4">
          {user && (
            <CreateSocietyForm
              societyTypeDisplayName={societyTypeDisplayName}
              user={user}
            />
          )}
        </div>
      </div>
    </ErrorBoundary>
  )
}
